/* ============
 * Embed Component
 * ============
 *
 * todo: add documentation here!
 */

export default {
  data() {
    return {
      previewMessage: this.message,
      previewSubject: this.subject,
      previewEmailTo: this.to,
      previewEmailCC: this.cc,
      previewEmailBCC: [],
    };
  },
  computed: {
    //
  },
  mounted() {
    //
  },
  created() {
    //
  },
  methods: {
    //
  },

  props: {

    /**
     * The message
     */
    message: {
      type: String,
      required: true,
    },

    /**
     * The subject
     */
    subject: {
      type: String,
      required: true,
    },

    to: {
      type: Array,
      required: false,
    },

    cc: {
      type: Array,
      required: false,
    },

    bcc: {
      type: Array,
      required: false,
    },
  },

  watch: {
    //
  },
};



// WEBPACK FOOTER //
// ./src/app/components/previewMessageCopy/previewMessageCopy.js